import * as ActionConfigurationManager from './config.actions';

export const singleFlowProductChanged = ActionConfigurationManager.SINGLE_FLOW_PRODUCT_CHANGED
export const resetSingleFlowProductChanged = ActionConfigurationManager.RESET_SINGLE_FLOW_PRODUCT_CHANGED
